import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ToolSidebar from "../utils/ToolSideBar";
import { API_URL, authFetch } from "../utils/auth";
import "../../css/staff/InternalWorkspace.css";

const reviewStatuses = [
  ["new", "New"],
  ["under_review", "Under Review"],
  ["more_information_needed", "More Information Needed"],
  ["approved", "Approved"],
  ["declined", "Declined"],
];

export default function ProjectRequestsPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [partnerFilter, setPartnerFilter] = useState("");

  const loadRequests = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status) params.set("review_status", status);
    if (partnerFilter) params.set("has_partner", partnerFilter);
    try {
      const response = await authFetch(`${API_URL}/staff/project-requests/${params.toString() ? `?${params}` : ""}`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to load project requests.");
      setRequests(data.results || []);
      setError("");
    } catch (err) {
      setError(err.message || "Unable to load project requests.");
    } finally {
      setLoading(false);
    }
  }, [search, status, partnerFilter]);

  useEffect(() => { loadRequests(); }, [loadRequests]);

  return (
    <div className="staff-shell">
      <ToolSidebar active="project-requests" />
      <main className="staff-page internal-page">
        <header className="staff-header internal-hero">
          <span>SCD Review</span>
          <h1>Project Requests</h1>
          <p>Review submitted requests before they become active delivery projects.</p>
        </header>
        <section className="staff-card internal-toolbar request-review-toolbar">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search client, email, or business" />
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">All statuses</option>
            {reviewStatuses.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
          <select value={partnerFilter} onChange={(e) => setPartnerFilter(e.target.value)}>
            <option value="">Any partner</option>
            <option value="true">Has partner</option>
            <option value="false">No partner</option>
          </select>
          <button type="button" onClick={loadRequests}>Filter</button>
        </section>
        <section className="staff-card">
          {loading ? <p className="staff-empty inline">Loading project requests...</p> : error ? <p className="staff-empty inline">{error}</p> : requests.length === 0 ? <p className="staff-empty inline">No project requests match those filters.</p> : (
            <div className="staff-table-wrap"><table className="staff-table internal-table"><thead><tr><th>Request</th><th>Client</th><th>Requested Service</th><th>Budget</th><th>Timeline</th><th>Partner</th><th>Status</th><th>Submitted</th></tr></thead><tbody>{requests.map((item) => <tr key={item.id}><td><Link to={`/project-requests/${item.id}`} className="staff-strong-link">{item.business_name || "Project Request"}</Link><small>{item.source}</small></td><td>{item.client_name}<small>{item.email}</small></td><td>{item.requested_service}</td><td>{item.budget}</td><td>{item.timeline}</td><td>{item.referring_partner}</td><td><span className={`review-pill review-${item.review_status}`}>{item.review_status_label}</span></td><td>{new Date(item.submitted_at).toLocaleDateString()}</td></tr>)}</tbody></table></div>
          )}
        </section>
      </main>
    </div>
  );
}